import React from "react";

import './style.css'

export const Navigation = () => {
  return (
    <header className="header-area header-sticky">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <nav className="main-nav">
              <a href="/" className="logo">
                <img src="./assets/images/logo.png" alt="Логотип" />
              </a>
              <ul className="nav">
                <li className="scroll-to-section">
                  <a href="#portfolio">Портфолио</a>
                </li>
                <li className="scroll-to-section">
                  <a href="#pricing">Услуги</a>
                </li>
                <li className="scroll-to-section">
                  <a href="#statement">Этапы работ</a>
                </li>
                {/* 
                <li className="scroll-to-section">
                  <a href="#contact">Контакты</a>
                </li>
                */}
              </ul>
              <a className='menu-trigger'>
                <span>Menu</span>
              </a>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};